export default {
  liteVersion: {},
  header: {},
  modalTitle: {},
  content: {},
  first: {},
  contentModule: {},
  contentModuleRow: {},
  contentModuleCell: {},
  contentModuleCellPrice: {},
  contentModuleCellPriceInfo: {},
  hotelInfoHeader: {},
  hotelTitle: {},
  short: {},
  large: {},
  finalPrice: {},
  last: {},
  defaultStyle: {
    background: '#fff',
    '& $liteVersion': {
      background: '#f1f1f1'
    },
    '&:lang(ar)': {
      direction: "rtl"
    },
    '& $header': {
      position: 'relative',
      display: 'block',
      padding: '11px 20px 14px 20px',
      '&:after': {
        content: "''",
        position: 'absolute',
        left: '0',
        right: '0',
        bottom: '0',
        borderBottom: '1px solid #d8d8d8'
      },
      '& $modalTitle': {
        font: "18px 'Droid Serif'",
        '@media (min-width: 901px)': {
          fontSize: '24px'
        }
      },
      '@media (min-width: 901px)': {
        padding: '17px 20px 12px 20px'
      }
    },
    '& $content': {
      '& $contentModuleRow:not(:first-of-type)': {
        '& $contentModuleCell': {
          paddingTop: '10px'
        }
      },
      '& $contentModule': {
        '&$first': {
          padding: '0',
          position: 'relative',
          '& $hotelInfoHeader': {
            padding: '10px 20px 6px',
            '& $hotelTitle': {
              font: "500 16px 'Roboto'",
              display: 'block',
              '@media (min-width: 801px)': {
                fontSize: '24px',
                fontWeight: 'normal'
              }
            },
            '@media (min-width: 801px)': {
              padding: '10px 30px 13px'
            }
          },
          '@global > button': {
            margin: '0 20px'
          },
          '&:after': {
            content: "''",
            position: 'absolute',
            left: '20px',
            right: '20px',
            bottom: '0',
            borderBottom: '1px solid #d8d8d8',
            '@media (min-width: 901px)': {
              left: '30px',
              right: '30px'
            }
          }
        },
        padding: '18px 20px 19px',
        display: 'table',
        width: '100%',
        position: 'relative',
        boxSizing: 'border-box',
        '& $contentModuleRow': {
          display: 'table-row',
          '& $contentModuleCell': {
            display: 'table-cell',
            width: '50%',
            '&$short': {
              width: '35%'
            },
            '&$large': {
              width: '65%'
            }
          },
          '& $contentModuleCellPrice': {
            textAlign: 'right',
            '&:lang(ar)': {
              textAlign: "left"
            }
          }
        },
        '@media (min-width: 901px)': {
          padding: '15px 30px'
        },
        '&$contentModuleCellPriceInfo': {
          '& $contentModuleRow': {
            '& $contentModuleCell': {
              padding: '0 0 7px',
              '&:not(:first-of-type)': {
                maxWidth: '200px',
                wordBreak: 'break-word',
                paddingTop: 0
              }
            },
            '&:after': {
              position: 'absolute',
              borderBottom: '1px solid #d8d8d8',
              left: '20px',
              right: '20px',
              content: "''",
              bottom: '0',
              '@media (min-width: 901px)': {
                left: '30px',
                right: '30px'
              }
            }
          }
        },
        '&:not(:first-of-type):before': {
          content: "''",
          position: 'absolute',
          left: '20px',
          right: '20px',
          bottom: '0',
          borderBottom: '1px solid #d8d8d8',
          '@media (min-width: 901px)': {
            left: '30px',
            right: '30px'
          }
        },
        '&$finalPrice': {
          '& $contentModuleRow': {
            '& $contentModuleCell': {
              paddingTop: '0'
            }
          }
        },
        '&$last': {
          border: 'none',
          '&:before': {
            content: 'none'
          }
        }
      }
    }
  },
  hide: {
    display: 'none'
  },
  confirmationSummary: {
    background: '#f1f1f1'
  },
  summaryModal: {
    '& $header': {
      position:'sticky',
      top:0,
      backgroundColor:'#fff',
      zIndex:1
    }
  }
};
